import { render, staticRenderFns } from "./orderPayDetail.vue?vue&type=template&id=dfee56aa&scoped=true&"
import script from "./orderPayDetail.vue?vue&type=script&lang=js&"
export * from "./orderPayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfee56aa",
  null
  
)

export default component.exports